import { format } from "date-fns";
import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";

interface BillingCycleInfoProps {
  startDate: number;
}

export const BillingCycleInfo = ({ startDate }: BillingCycleInfoProps) => (
  <div className="my-4">
    <Typography.LabelSm color="text-light">
      {t("settings.billing.ai_actions.usage_this_month_starting_from", {
        date: format(new Date(startDate * 1000), "MMM d, yyyy"),
      })}
    </Typography.LabelSm>
  </div>
);
